import React, { useState, useEffect } from "react";
import { ArrowLeft, PlusCircle, Eye, Edit } from "react-feather";
import { Link } from "react-router-dom";
import Table from "core/pagination/datatable";
import TableTop from "Components/UI/TableTop";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { useTableSearch } from "core/Operations/useTableSearch";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import Error404 from "MainPages/ErrorPages/error404";
import { useVehicleExpensesCategoriesQuery } from "AppQuries/master/VehicleExpenses/vehicleexpenses";
import { BackIcon } from "Components/UI/Icon/Icons";
const VehicleExpenses = () => {
  const userData = useSelector(loggedInUser);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch: GetItems,
  } = useVehicleExpensesCategoriesQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [show, setShow] = useState(false);

  const ItemData = data?.map((d, _id) => ({
    id: _id + 1,
    ...d,
  }));

  console.log(data);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Expense ID",
      dataIndex: "expenseID",
      sorter: (a, b) => a.expenseID - b.expenseID,
    },
    {
      title: "Vehicle Number",
      dataIndex: "vehicleNumber",
      sorter: (a, b) => a.vehicleNumber.localeCompare(b.vehicleNumber),
    },
    {
      title: "Insurance Number",
      dataIndex: "insuranceNumber",
    },
    {
      title: "Insurance Period",
      dataIndex: "insurancePeriod",
    },
    {
      title: "Insurance Amount",
      dataIndex: "insuranceAmount",
      sorter: (a, b) => a.insuranceAmount - b.insuranceAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Insurance Vendor",
      dataIndex: "insuranceVendor",
    },
    {
      title: "Insurance Agency",
      dataIndex: "insuranceAgency",
    },
    {
      title: "Insurance Expiry Date",
      dataIndex: "insuranceExpiryDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.insuranceExpiryDate) - new Date(b.insuranceExpiryDate),
    },
    {
      title: "Crane Insurance Expiry Date",
      dataIndex: "craneInsuranceExpiryDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.craneInsuranceExpiryDate) -
        new Date(b.craneInsuranceExpiryDate),
    },
    {
      title: "Lorry Crane LM Cert Expiry Date",
      dataIndex: "lorryCraneLMCertExpiryDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.lorryCraneLMCertExpiryDate) -
        new Date(b.lorryCraneLMCertExpiryDate),
    },
    {
      title: "LG Next Due Date",
      dataIndex: "lgNextDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.lgNextDueDate) - new Date(b.lgNextDueDate),
    },
    {
      title: "Road Tax Due Date",
      dataIndex: "roadTaxDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.roadTaxDueDate) - new Date(b.roadTaxDueDate),
    },
    {
      title: "Inspection Due Date",
      dataIndex: "inspectionDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.inspectionDueDate) - new Date(b.inspectionDueDate),
    },
    {
      title: "Road Tax Inspection Amount",
      dataIndex: "roadTaxInspectionAmount",
      sorter: (a, b) => a.roadTaxInspectionAmount - b.roadTaxInspectionAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Road Tax Inv Ref",
      dataIndex: "roadTaxInvRef",
    },
    {
      title: "NCD",
      dataIndex: "ncd",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      title: "Parking Next Due Date",
      dataIndex: "parkingNextDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.parkingNextDueDate) - new Date(b.parkingNextDueDate),
    },
    {
      title: "VPC",
      dataIndex: "vpc",
    },
    {
      title: "VPC Amount",
      dataIndex: "vpcAmount",
      sorter: (a, b) => a.vpcAmount - b.vpcAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "VPC Address",
      dataIndex: "vpcAddress",
    },
    {
      title: "Parking Vendor",
      dataIndex: "parkingVendor",
    },
    {
      title: "Parking Location",
      dataIndex: "parkingLocation",
    },
    {
      title: "Parking Amount",
      dataIndex: "parkingAmount",
      sorter: (a, b) => a.parkingAmount - b.parkingAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Parking Coupon Next Due Date",
      dataIndex: "parkingCouponNextDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.parkingCouponNextDueDate) -
        new Date(b.parkingCouponNextDueDate),
    },
    {
      title: "Parking Address",
      dataIndex: "parkingAddress",
    },
    {
      title: "Parking Payment Mode",
      dataIndex: "parkingPaymentMode",
    },
    {
      title: "FMT Due Date",
      dataIndex: "fmtDueDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) => new Date(a.fmtDueDate) - new Date(b.fmtDueDate),
    },
    {
      title: "FMT Amount",
      dataIndex: "fmtAmount",
      sorter: (a, b) => a.fmtAmount - b.fmtAmount,
      render: (val) => `$${(val ?? 0).toFixed(2)}`,
    },
    {
      title: "Shell Card No",
      dataIndex: "shellCardNo",
    },
    {
      title: "Shell PIN",
      dataIndex: "shellPIN",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      render: (text) => (
        <>
          {text === true && (
            <div className="badges badge-linesuccess">Active</div>
          )}
          {text === false && (
            <div className="badges badge-linedanger">In Active</div>
          )}
        </>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="add-new-tooltip">Edit</Tooltip>}
          >
            <Link
              className="me-2 p-2"
              to={`${all_routes.master}/${all_routes.editvehicleexpenses}`}
            >
              <Edit className="feather-edit" />
            </Link>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    ItemData,
    searchColumns
  );

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isError) {
    return <Error404 error={error} />;
  }

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* <Breadcrumbs maintitle="Call History" subtitle="Manage your products" /> */}
          <div className="page-header">
            <div className="page-title">
              <h4>Company Vehicle Expenses Details</h4>
              {/* <nav aria-label="breadcrumb">
                <ol className="breadcrumb breadcrumb-arrow mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/">
                      <i className="fas fa-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="..">Master</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    CPF Contributions
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="page-btn" style={{ display: "flex" }}>
              <Link
                to={`${all_routes.master}/${all_routes.addvehicleexpenses}`}
                className="btn btn-added"
              >
                
                <PlusCircle className="me-2" />
                Add
              </Link>
              &nbsp;
              <Link
                to={`${all_routes.master}`}
                className="btn btn-secondary"
              >
       <i className="fas fa-reply me-2"></i>
                Back
              </Link>
            </div>
          </div>

          
          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
              />

              <div className="table-responsive">
                <Table
                  className="table  datanew"
                  columns={columns}
                  dataSource={filteredData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleExpenses;
